import React from 'react';
import { Avatar, Grid } from '@material-ui/core';
import Profile from '../../../../assets/img/profile.svg';
import useStyles from './styles';

type Props = {
  header: JSX.Element;
  content?: JSX.Element | string;
};

const ActivityBaseComment = ({ header, content }: Props) => {
  const classes = useStyles();

  return (
    <Grid container wrap="nowrap" className={classes.comment}>
      <Grid item>
        <Avatar alt="user pic" src={Profile} className={classes.avatar} />
      </Grid>
      <Grid item className={classes.text}>
        <div className={classes.header}>
          {header}
        </div>
        {content && (
          <div className={classes.content}>
            {content}
          </div>
        )}
      </Grid>
    </Grid>
  );
};

export default ActivityBaseComment;
